__turbopack_context__.v({
  "buttonContainer": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__5v6Jna__buttonContainer",
  "container": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__5v6Jna__container",
  "header": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__5v6Jna__header",
  "selectedButton": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__5v6Jna__selectedButton",
  "toggleButton": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__5v6Jna__toggleButton",
});
